import CloseableModalWithNavigation from './CloseableModalWithNavigation';

export default CloseableModalWithNavigation;
